import React from "react";
import { useSubject } from "../../context/SubjectContext";
import ReportScreen from "../../components/Reports/ReportScreen";
import { useNavigate } from "react-router-dom";
import {getQualificationTitle} from '../../utils/utils';

const ReportsLandingPage = () => {
  const navigate = useNavigate();
  const { subjectData , subjects} = useSubject();
  const reportData = {...subjectData?.subjectDetails,selectedSubject: subjectData.selectedSubject};
  const { selectedSubject, selectedSubjectCode } = subjectData || {};
  const onClickBackToDashboard = () => {
    navigate("/dashboard");
  };
  return (
    <div
      style={{
        paddingLeft: "25px",
        paddingRight: "25px",
        paddingBottom: "50px",
      }}
    >
      <div className="xcontainer">
        <section className="section mt-0 py-0">
          <div className="pt-5 subject-header-fixed">
            <p className="is-size-6 has-text-weight-bold">
             {getQualificationTitle(subjects, subjectData?.selectedSubjectId)}
            </p>
            <h1
              className="title mb-0"
              style={{
                fontSize: "24px",
                lineHeight: "32px",
              }}
            >
              {selectedSubject}{" "}
              {selectedSubjectCode && (
                <span className="is-size-6 has-text-weight-normal">
                  {selectedSubjectCode}
                </span>
              )}
            </h1>
            <p className="xbox xnotification is-info mt-0">Reports</p>
            <hr className="mb-0 mt-2" />
          </div>

          <div
            className="subject-page-content xpt-2"
            style={{ marginTop: "1em" }}
          >
            <div
              style={{ display: "flex" }}
              className="my-2 has-text-align-right"
              action-bar=""
            >
              <button
                style={{ letterSpacing: "0.5px" }}
                className="button is-text is-outlined"
                onClick={onClickBackToDashboard}
              >
                <span className="icon mr-2">
                  <svg
                    style={{ fill: "#0076BD" }}
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 -960 960 960"
                    width="24"
                  >
                    <path d="M560-253.847 333.847-480 560-706.153 602.153-664l-184 184 184 184L560-253.847Z"></path>
                  </svg>
                </span>
                Back to subject dashboard
              </button>
            </div>
          </div>
        </section>
      </div>

      <ReportScreen reportData={reportData} />
    </div>
  );
};

export default ReportsLandingPage;
